import '@styles/common.scss';
import '@utils/i18n';
import 'core-js/actual';
import React from 'react';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import store from '@modules';

import App from '@containers/App';

const rootEl = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootEl);

const application = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

root.render(application);
